import { ShareLists } from "./types";

export const listDefaults: Partial<ShareLists> = {
  type: "Sample",
  artistCount: "multi",
  engagementType: "tourDates",
  marketType: "DMA",
  version: "v1",
};
